const MIN_LENGTH = 12;
const MAX_BYTES = 72;

const characterCount = (text) => Array.from(text).length;

const utf8Length = (text) =>
  encodeURIComponent(text).replace(/%[0-9A-F]{2}/g, '_').length;

const RULES = [
  [
    (password) => characterCount(password) >= MIN_LENGTH,
    `Password must be at least ${MIN_LENGTH} characters`,
  ],
  [
    (password) => utf8Length(password) <= MAX_BYTES,
    `Password must be at most ${MAX_BYTES} bytes (ä, ö and emoji count as 2–4)`,
  ],
  [
    (password) => /\p{Ll}/u.test(password),
    'Password must contain a lowercase letter',
  ],
  [
    (password) => /\p{Lu}/u.test(password),
    'Password must contain an uppercase letter',
  ],
  [(password) => /\p{N}/u.test(password), 'Password must contain a number'],
  [
    (password) => /[^\p{L}\p{N}]/u.test(password),
    'Password must contain a special character',
  ],
];

export const ADMIN_PASSWORD_REQUIREMENTS = `At least ${MIN_LENGTH} characters with upper and lower case letters, a number and a special character`;

export const adminPasswordProblems = (password = '') =>
  RULES.filter(([isMet]) => !isMet(password)).map(([, message]) => message);

export const canSaveAdminPassword = (admin) =>
  admin.password
    ? adminPasswordProblems(admin.password).length === 0
    : Boolean(admin._id);
